// Check if element is in view
export function isElementInView(elem) {
  const elemPosition = elem.getBoundingClientRect();
  return (elemPosition.top <= (window.innerHeight || document.documentElement.innerHeight));
}

/**
* Helper method to return scroll value on all browser
*/
export function getScrollTop() {
  let target;
  if (window.pageYOffset) return window.pageYOffset; // most browsers except IE before #9
  target = document.documentElement; // IE with doctype
  target = (target.clientHeight) ? target : document.body;
  return target.scrollTop;
}

// Debounce

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction() {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;

    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function setBannerHeight() {
  const banner = document.querySelector('.hero');
  if (banner) {
    const bannerHeight = banner.clientHeight;
    document.querySelector('main').style.cssText = `top:${bannerHeight}px`;
  }
}

/* header fixed */

export function stickyHeader() {
  const headerHeight = document.querySelector('header').clientHeight;
  const mainOffset = document.querySelector('main').offsetTop;
  if (document.querySelector('.hero')) {
    if (document.body.scrollTop > mainOffset - headerHeight
        || document.documentElement.scrollTop > mainOffset - headerHeight) {
      document.querySelector('header').classList.add('header--fixed');
    } else {
      document.querySelector('header').classList.remove('header--fixed');
    }
  } else if (document.body.scrollTop > 70 || document.documentElement.scrollTop > 70) {
    document.querySelector('header').classList.add('header--fixed');
  } else {
    document.querySelector('header').classList.remove('header--fixed');
  }
}

export function animateElements() {
  const animatedElements = document.querySelectorAll('.js-animate');
  if (animatedElements) {
    animatedElements.forEach((elem) => {
      if (isElementInView(elem)) {
        if (elem && elem.classList) {
          elem.classList.add('has-animated');
        }
      }
    });
  }
}

function easeInOut(currentTime, start, change, duration) {
  let currentTimeRef = currentTime;
  currentTimeRef /= duration / 2;
  if (currentTimeRef < 1) {
    return change / 2 * currentTimeRef * currentTimeRef + start;
  }
  currentTimeRef -= 1;
  return -change / 2 * (currentTimeRef * (currentTimeRef - 2) - 1) + start;
}

export function scrollSection(end, duration) {
  const start = 0;
  const change = end;
  const increment = 20;

  const animateScroll = (elapsedTime) => {
    let elapsedTimeRef = elapsedTime;
    elapsedTimeRef += increment;
    const position = easeInOut(elapsedTimeRef, start, change, duration);
    document.documentElement.scrollTop = position;
    if (elapsedTimeRef < duration) {
      setTimeout(() => {
        animateScroll(elapsedTimeRef);
      }, increment);
    }
  };
  animateScroll(0);
}

export const convertStringToURL = (urlString) => {
  try {
    return new URL(urlString);
  } catch (e) {
    console.error('invalid url: ', urlString);
  }
  return undefined;
};
